import { Card } from "../../cards-engine/components/card/models/card.model";
import { Category } from "../../cards-engine/models/cards-engine.model";

export enum ModalType {
  CONTAINER_CARDS = 'containerCards',
  ATTACHMENTS_CARDS = 'attachmentsCards'
}

export interface Modal {
  modalType: ModalType;
  player: string;
  title: string;
  category: Category;
  content: Card;
}